export const CATEGORIES = [
  { value: 'COWORKING', label: 'Coworking' },
  { value: 'MEETING_ROOM', label: 'Salle de réunion' },
  { value: 'OFFICE', label: 'Bureau' },
  { value: 'EVENT_SPACE', label: 'Espace événementiel' },
  { value: 'OTHER', label: 'Autre' },
];

export const SPACE_WORKFLOWS = [
  { value: 'IMMEDIATE', label: 'Immédiat (paiement direct)' },
  { value: 'QUOTE_REQUIRED', label: 'Devis requis' },
  { value: 'APPLICATION_REQUIRED', label: 'Candidature requise' },
];

export const ALLOWED_SCALAR_FIELDS = [
  'name',
  'slug',
  'category',
  'description',
  'shortDesc',
  'workflow',
  'colorPrimary',
  'colorAccent',
  'iconName',
  'imageUrl',
  'bannerUrl',
  'isActive',
  'isPublic',
  'order',
  'subtitle',
  'badge',
  'badgeColor',
  'gradient',
  'ctaLabel',
  'priceFromLabel',
  'priceFromDetail',
  'defaultDuration',
  'metaTitle',
  'metaDescription',
  'importantNotes',
  'formSchema',
  'validationRules',
  'requireCompanyName',
  'companyFieldLabel',
  'requireCompanyInfo',
  'requireCompanyPhone',
  'requireCompanyEmail',
  'requireCompanyWebsite',
  'companyPhoneLabel',
  'companyEmailLabel',
  'companyWebsiteLabel',
  'requireBookingReason',
  'bookingReasonLabel',
  'eventTypesEnabled',
  'requireEventObjectives',
  'eventObjectivesLabel',
  'allowMultiDay',
  'allowHalfDay',
  'allowFullDay',
  'allowMonth',
  'fullDayHours',
  'halfDayHours',
  'quoteDelayHours',
  'urgentQuotePrice',
  'urgentQuoteDelayHours',
  'quoteRules',
  'equipmentsEnabled',
  'roomLayoutsEnabled',
  'cateringEnabled',
];
